(function () {
    'use strict';

    var module = angular.module('uwAgenda.ringfoon');
    module.directive('quickSidebarUserSearchItem', [UserSearchItemDirectiveFn]);

    /* directive for user-search item in search-list */
    function UserSearchItemDirectiveFn() {

        var directive = {
            restrict: 'A',
            templateUrl: '/app/ringfoon/templates/quick-sidebar-user-search-item.template.html',
            scope: {
                user: '=',
                address: '=',
            },
            link: link
        };
        return directive;

        function link(scope, element) {
            // destroy
            element.on("$destroy", function () {
                // destory scope
                scope.$parent.$destroy(); // also destroy parent scope
                scope.$destroy(); // have to destroy it manually, because of own scope-creation
            });

        } // link
    }

})();